

import axios from "axios"
import { useEffect, useState } from "react";
import passTemplate from "./Candidates_VIP.png";
import QRCode from "qrcode";

import "./Pass.css"
import { Axios } from "../../Services/Axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const Toast = ({ message, type, onClose }) => {
    if (!message) return null;

    return (
        <div className="toast-container">
            <div className={`toast ${type === "error" ? "toast-error" : "toast-success"}`}>
                <div className="toast-content">
                    <p>{message}</p>
                    <button onClick={onClose} className="toast-close">×</button>
                </div>
            </div>
        </div>
    );
};

export const Pass = () => {
    const [passes, setPasses] = useState([]);
    const [loading, setLoading] = useState(null);
    const [VisitorPassesCount, setVisitorPassesCount] = useState(0);
    const [ConferencePassesCount, setConferencePassesCount] = useState(0);
    const [VIPPassesCount, setVIPPassesCount] = useState(0);
    const [toast, setToast] = useState({ message: "", type: "" });
    const BASE_URL = "https://webbackend.aptech-education.com.pk";



    function wrapText(ctx, text, x, y, maxWidth, lineHeight) {
        const words = text.split(" ");
        let line = "";
        for (let n = 0; n < words.length; n++) {
            const testLine = line + words[n] + " ";
            const metrics = ctx.measureText(testLine);
            if (metrics.width > maxWidth && n > 0) {
                ctx.fillText(line, x, y);
                line = words[n] + " ";
                y += lineHeight;
            } else {
                line = testLine;
            }
        }
        ctx.fillText(line, x, y);
        return y + lineHeight;
    }

    const showToast = (message, type = "success") => {
        setToast({ message, type });
        setTimeout(() => setToast({ message: "", type: "" }), 3000);
    };

    const getImage = async (url) => {
        try {
            const response = await axios.post(
                `${BASE_URL}/api/ConversationAttachment/GetFileUrl?url=${url}`,
                {},
                { responseType: "arraybuffer" }
            );
            const blob = new Blob([response.data], { type: "image/png" });
            return URL.createObjectURL(blob);
        } catch (err) {
            console.error("Error fetching image:", err);
            return null;
        }
    };


    const handleApprove = async (passData) => {
        setLoading(passData.id);
        const { id, firstName, lastName, email, phone, organization, designation, profileImage } = passData;

        await new Promise(async (resolve, reject) => {
            const img = new Image();
            img.crossOrigin = "anonymous";
            img.src = passTemplate;

            img.onload = async () => {
                const canvas = document.createElement("canvas");
                const scale = 2;
                canvas.width = 420 * scale;
                canvas.height = 686 * scale;
                const ctx = canvas.getContext("2d");

                if (!ctx) {
                    reject(new Error("Failed to get canvas context"));
                    return;
                }

                ctx.drawImage(img, 0, 0, 420 * scale, 686 * scale);

                // ✅ Profile Image
                if (profileImage) {
                    try {
                        const profileUrl = await getImage(profileImage);
                        if (profileUrl) {
                            await new Promise((res, rej) => {
                                const profileImg = new Image();
                                profileImg.crossOrigin = "anonymous";
                                profileImg.src = profileUrl;

                                profileImg.onload = () => {
                                    const profileSize = 200;
                                    const profileX = (520 - profileSize) / 1;
                                    const profileY = 363;

                                    ctx.save();
                                    ctx.beginPath();
                                    ctx.arc(
                                        profileX + profileSize / 2,
                                        profileY + profileSize / 2,
                                        profileSize / 2,
                                        0,
                                        Math.PI * 2,
                                        true
                                    );
                                    ctx.closePath();
                                    ctx.clip();

                                    ctx.drawImage(profileImg, profileX, profileY, profileSize, profileSize);
                                    ctx.restore();
                                    res(true);
                                };

                                profileImg.onerror = rej;
                            });
                        }
                    } catch (err) {
                        console.error("Error loading profile image:", err);
                    }
                }

                // ✅ Add Text
                ctx.fillStyle = "#fff";
                ctx.textAlign = "center";
                const centerX = 415;
                let yPos = 600;

                ctx.font = "bold 28px Helvetica";
                ctx.fillText(`${firstName} ${lastName}`, centerX, yPos);
                yPos += 40;

                yPos = wrapText(ctx, `Organization: ${organization}`, centerX, yPos, 650, 40);
                yPos = wrapText(ctx, `Designation: ${designation}`, centerX, yPos, 650, 40);

                // ✅ QR Code
                const qrDataUrl = await QRCode.toDataURL(id.toString(), {
                    width: 100,
                    margin: 1,
                });

                const qrImg = new Image();
                qrImg.src = qrDataUrl;

                qrImg.onload = () => {
                    // ctx.drawImage(qrImg, 320, 790, 200, 200);

                    canvas.toBlob(async (blob) => {
                        if (!blob) {
                            reject(new Error("Failed to create blob"));
                            return;
                        }

                        const file = new File([blob], "aptech-vision-pass.png", {
                            type: "image/png",
                        });

                        // ✅ Send Email
                        const emailForm = new FormData();
                        emailForm.append("Email", email);
                        emailForm.append("Subject", "Confirmation as VIP Delegate – Aptech Vision 2026 🚀");
                        emailForm.append(
                            "Body",
                            `<p>Dear ${firstName} ${lastName},</p>

  <p>We are honored to welcome you as a <strong>VIP Delegate</strong> for 
  <strong>Aptech Vision 2026</strong>, taking place on 
  <strong>Saturday, 22 August 2026</strong> at 
  <strong>PC Hotel, Karachi</strong>.</p>

  <p>As our esteemed VIP guest, you are also invited to attend the Conference on 
  <em>“Tech Dialogue Pakistan”</em>.</p>

  <p>
    📅 <strong>Date:</strong> Saturday, 22 August 2026<br>
    🕚 <strong>Time:</strong> 10:00 AM onwards<br>
    📍 <strong>Venue:</strong> Pearl Continental Hotel, Karachi
  </p>

  <p><strong>Note:</strong> Your attached VIP Delegate Pass is issued exclusively in your name and is non-transferable. The QR code on the pass will be scanned at the registration desk for entry. Kindly bring a valid ID (such as CNIC or Company ID card) for cross-verification to ensure a smooth check-in process.</p>

  <p>We look forward to hosting you at <strong>Aptech Vision 2026</strong> for an inspiring and memorable experience! 🚀</p>

  <p>Best Regards,<br>
  <strong>Aptech Pakistan Team</strong></p>`
                        );

                        emailForm.append("Pass", file);

                        await fetch(`${BASE_URL}/api/Attendee/SendEmail`, {
                            method: "POST",
                            body: emailForm,
                        });


                        // ✅ Update Status formData
                        const statusForm = new FormData();
                        statusForm.append("Id", id);
                        //do for all
                        statusForm.append("FirstName", firstName);
                        statusForm.append("LastName", lastName);
                        statusForm.append("Email", email);
                        statusForm.append("Phone", phone);
                        statusForm.append("Organization", organization);
                        statusForm.append("Designation", designation);
                        if (profileImage) {
                            statusForm.append("ProfileImage", profileImage);
                        }
                        statusForm.append("AttendeeType", "VIP");
                        statusForm.append("Status", "3"); // Approved

                        await fetch(`${BASE_URL}/api/Attendee/Update`, {
                            method: "PUT",
                            body: statusForm,
                        });






                        // Refresh passes
                        fetchPasses();


                        // // ✅ Download locally
                        // const a = document.createElement("a");
                        // a.href = URL.createObjectURL(file);
                        // a.download = "aptech-vision-pass.png";
                        // document.body.appendChild(a);
                        // a.click();
                        // document.body.removeChild(a);
                        setLoading(null);
                        showToast("Pass approved and email sent!");
                        resolve(true);
                    }, "image/png");
                };
            };

            img.onerror = reject;
        });
    };


    useEffect(() => {
        fetchPasses();
    }, []);

    const fetchPasses = () => {
        axios
            .get(`${BASE_URL}/api/Attendee/GetAll`)
            .then((res) => {
                let filteredData = res.data?.reverse();
                filteredData = filteredData.filter((e) => e.attendeeType === "VIP" && e.status !== 3);
                let uniqueVip = [...new Map(filteredData.map(item => [item.email, item])).values()];
                console.log(uniqueVip);

                console.log(filteredData,"VIP");
                let visitors = res.data.filter((e) => e.attendeeType === "VISITOR");
                let uniqueVisitors = [...new Map(visitors.map(item => [item.email, item])).values()];
                let uniqueByPhone = [...new Map(uniqueVisitors.map(item => [item.phone, item])).values()];
                uniqueVisitors = uniqueByPhone;
                let count = uniqueVisitors.length;
                let conferencePassesCount = res.data.filter((e) => e.attendeeType === "CONFERENCE");
                let uniqueconference = [...new Map(conferencePassesCount.map(item => [item.email, item])).values()];
                let conferencecount = uniqueconference.length;
                setConferencePassesCount(conferencecount);
                let vipCount = res.data.filter((e) => e.status === 3).length;
                setVIPPassesCount(vipCount);
                setVisitorPassesCount(count);
                setPasses(filteredData);
            })
            .catch((err) => console.log(err));
    };



    // const RemovePass = (pass) => {
    //     console.log(pass.id);
    //     Axios.delete(`${BASE_URL}/api/Attendee/Remove?id=${pass.id}`)
    //         .then((res) => {
    //             showToast("Pass removed successfully");
    //             fetchPasses();
    //         })
    //         .catch((err) => {
    //             showToast("Error removing pass", "error");
    //         });

    // }


    const [loading1, setLoading1] = useState(false);

    const ExportData = async () => {
        try {
            setLoading1(true);
            const res = await axios.get(`${BASE_URL}/api/Attendee/GetAll`);

            const allData = res.data || [];

            // --- FILTER VIPs (excluding status 3)
            let vipData = allData.filter(
                (e) => e.attendeeType === "VIP" && e.status === 3
            );

            // --- FILTER Visitors
            let visitorData = allData.filter((e) => e.attendeeType === "VISITOR");

            // --- REMOVE DUPLICATES (by email → then by phone)
            const uniqueByEmail = (data) => [
                ...new Map(data.map((item) => [item.email, item])).values(),
            ];
            const uniqueByPhone = (data) => [
                ...new Map(data.map((item) => [item.phone, item])).values(),
            ];

            // vipData = uniqueByPhone(uniqueByEmail(vipData));
            visitorData = uniqueByPhone(uniqueByEmail(visitorData));

            // --- PREPARE WORKBOOK
            const workbook = XLSX.utils.book_new();
            const visitorSheet = XLSX.utils.json_to_sheet(visitorData);
            // const vipSheet = XLSX.utils.json_to_sheet(vipData);

            XLSX.utils.book_append_sheet(workbook, visitorSheet, "Visitors");
            // XLSX.utils.book_append_sheet(workbook, vipSheet, "VIPs");

            // --- GENERATE FILE
            const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
            saveAs(new Blob([wbout], { type: "application/octet-stream" }), "Passes.xlsx");

            setLoading1(false);
        } catch (err) {
            console.error("Error fetching/exporting data:", err);
            setLoading1(false);
        }
    };


    return (
        <div className="app">
            <div className="container">
                {/* Header */}
                <header className="header">
                    <h1>E-Pass Management</h1>
                    <p>Review and approve pending VIP pass requests</p>
                </header>
                 {/* <button
                    onClick={ExportData}
                    disabled={loading1}
                    className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                >
                    {loading1 ? "Exporting..." : "Export Visitors & VIPs"}
                </button>  */}

                {/* Stats */}
                <div className="stats">
                    <div className="stat-card">
                        <div>
                            <p>VIP Pending Passes</p>
                            <h2>{passes.filter((e) => e.status === null || e.status === 0).length}</h2>
                        </div>
                    </div>
                    <div className="stat-card">
                        <div>
                            <p>VIP Passes Approved</p>
                            <h2>{VIPPassesCount}</h2>
                        </div>
                    </div>
                    <div className="stat-card">
                        <div>
                            <p>VISITOR Passes</p>
                            <h2>{VisitorPassesCount}</h2>
                        </div>
                    </div>
                    <div className="stat-card">
                        <div>
                            <p>Conference Passes</p>
                            <h2>{ConferencePassesCount}</h2>
                        </div>
                    </div>
                </div>

                {/* Pending Requests */}
                <section>
                    <h2>VIP Pending Requests</h2>
                    {passes.length === 0 ? (
                        <div className="empty-state">No pending VIP pass requests</div>
                    ) : (
                        <div className="pass-list">
                            {passes.map((pass) => (
                                <div key={pass.id} className="pass-card">
                                    <div className="pass-header">
                                        <img src={`${BASE_URL}/${pass?.profileImage}`} alt="" />
                                        <div>
                                            <h3>{pass?.firstName + " " + pass?.lastName}</h3>
                                            <p>{pass.designation + " - " + pass?.organization}</p>
                                        </div>

                                    </div>
                                    <div
                                        style={{
                                            textAlign: "right"
                                            ,
                                            marginRight: "50px"
                                        }}
                                    >
                                        <span className={`status ${pass?.status === 3 ? "approved" : "pending"}`}>
                                            {pass?.status === 3 ? "Approved" : "Pending"}
                                        </span>
                                    </div>

                                    <div className="pass-body">
                                        <div>
                                            <p className="label">Email</p>
                                            <p>{pass?.email}</p>
                                            <p>{pass?.phone}</p>
                                        </div>
                                        <div>
                                            <p className="label">Request Date</p>
                                            <p>{pass?.createdDate.split("T")[0]}</p>
                                        </div>
                                    </div>

                                    <div className="actions">
                                        <button
                                            onClick={() => handleApprove(pass)}
                                            disabled={loading === pass.id || pass?.status === 3}
                                            className="btn btn-approve"
                                        >
                                            {loading === pass.id ? "Approving..." : pass?.status === 3 ? "Approved" : "Approve"}
                                        </button>

                                        {/* <button
                                            onClick={() => RemovePass(pass)}
                                          
                                            className="btn btn-approve"
                                        >
                                            {loading === pass.id ? "Remove..." : pass?.status === 3 ? "Removed" : "Remove"}
                                        </button> */}

                                        {pass?.status === 3 && (
                                            <button onClick={() => handleApprove(pass)} className="btn btn-resend">
                                                Resend VIP e-Pass via Email
                                            </button>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </section>
            </div>
            <Toast message={toast.message} type={toast.type} onClose={() => setToast({ message: "", type: "" })} />
        </div>
    );;
}
